import "./Fundas.css";
import banner from "../../assets/fundas.jpg";

const Fundas = () => {
  return (
    <div className="fundas">
      <img src={banner} alt="Fundas banner" className="fundas-banner" />
    </div>
  );
};

export default Fundas;
